<template>
  <div class="pos-rlt fix-padding-top-print padder-v-md">
    <div class="app-footer wrapper-sm">
      <div class="row pos-rlt text-center">
        <div class="div-img-footer"></div>
        <div class="col-md-12">
          <nav class="link-list list-inline-ui m-b-none pull-left w-full" />
          <small class="app-footer-copy m-t-xs pull-left w-full">
            Copyright © {{ dateAtual }} Zucchetti. Todos os direitos reservados
          </small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "Footer",
  data() {
    return {
      dateAtual: moment().format("YYYY")
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/client/public/Footer.vue